// DMC country inventory — ISO3 → display name (US-877 · R-3).
//
// ONE list of the selectable Developing Member Countries, derived from
// selectionConfig.SELECTABLE_ISO3 so it can never drift from the drill's rules:
// China (absent there per ADB rule R-6) can therefore never be an option here.
// This module holds ONLY display labels — no selection rules, no data fetch;
// those stay in selectionConfig / SelectionContext (design §2, AGENTS.md §3).
// A test asserts every SELECTABLE_ISO3 has a name here.
import { SELECTABLE_ISO3 } from "./selectionConfig";

// ISO3 → human-readable economy name (ADB conventions where they differ from the
// common short form: "Viet Nam", "Lao PDR", "Kyrgyz Republic", "Hong Kong, China",
// "Republic of Korea"). Kept alphabetical by ISO3 for easy auditing against the
// SELECTABLE_ISO3 set.
const NAMES = {
  AFG: "Afghanistan",
  ARM: "Armenia",
  AZE: "Azerbaijan",
  BGD: "Bangladesh",
  BRN: "Brunei Darussalam",
  BTN: "Bhutan",
  FJI: "Fiji",
  FSM: "Federated States of Micronesia",
  GEO: "Georgia",
  HKG: "Hong Kong, China",
  IDN: "Indonesia",
  IND: "India",
  KAZ: "Kazakhstan",
  KGZ: "Kyrgyz Republic",
  KHM: "Cambodia",
  KIR: "Kiribati",
  KOR: "Republic of Korea",
  LAO: "Lao PDR",
  LKA: "Sri Lanka",
  MDV: "Maldives",
  MMR: "Myanmar",
  MNG: "Mongolia",
  MYS: "Malaysia",
  NPL: "Nepal",
  NRU: "Nauru",
  PAK: "Pakistan",
  PHL: "Philippines",
  PNG: "Papua New Guinea",
  SGP: "Singapore",
  SLB: "Solomon Islands",
  THA: "Thailand",
  TJK: "Tajikistan",
  TKM: "Turkmenistan",
  TLS: "Timor-Leste",
  TON: "Tonga",
  TUR: "Türkiye",
  TUV: "Tuvalu",
  UZB: "Uzbekistan",
  VNM: "Viet Nam",
  VUT: "Vanuatu",
  WSM: "Samoa",
};

// Selectable DMCs as { iso3, name }, sorted by name for the header dropdown.
// Built FROM SELECTABLE_ISO3, so the option list and the drill's selectable set
// are the same source of truth (R-6). A missing name falls back to the ISO3.
export const DMC_COUNTRIES = [...SELECTABLE_ISO3]
  .map((iso3) => ({ iso3, name: NAMES[iso3] || iso3 }))
  .sort((a, b) => a.name.localeCompare(b.name));

// iso3 → option, for O(1) lookup of the active dropdown value from a selection.
export const DMC_BY_ISO3 = DMC_COUNTRIES.reduce((acc, c) => {
  acc[c.iso3] = c;
  return acc;
}, {});

// Display name for an ISO3 (falls back to the code, then null). Used by the
// programmatic selectCountry so the breadcrumb reads a name without a tile query.
export const dmcName = (iso3) => DMC_BY_ISO3[iso3]?.name || iso3 || null;
